document.addEventListener("DOMContentLoaded", () => {
  let stories = document.querySelectorAll('.page__story');
  if (stories) {
    stories.forEach((story) => {
      let height = story.scrollHeight;
      story.style.height = `${height+30}px`;
    });
  }
});
